import React, { useEffect } from "react";
import "./styles.scss";
import CircularProgress from "@mui/material/CircularProgress";
import { connect } from "react-redux";
import DataRow from "./DataRow";
import { getStoreChecker, getDate } from "../../utils/utils";
import { useLazyQuery } from "@apollo/client";
import {
  GET_DEFAULT_LOCATION,
  GET_OMNI_CHANNEL_SUMMARY,
} from "../../graphql/queries.js";
import ErrorMessage from "../ErrorMessage";
import {
  DATA_FETCH_ERROR,
  ONLOAN_INVALID_STOREID_ERROR,
} from "../../common/constants";
import PropTypes from "prop-types";

const OmniChannelDetailTab = ({ employeeInfo = {}, dateMatrix }) => {
  const [selectedLocation, setSelectedLocation] = React.useState(
    JSON.parse(sessionStorage.getItem("selectedLocation"))
  );
  let selectedStoreId = localStorage.getItem("storeId");
  const activeStorechecker = getStoreChecker(selectedStoreId);
  const [getDefaultLocation, { error: locationError = {} }] = useLazyQuery(
    GET_DEFAULT_LOCATION,
    {
      onCompleted: (data) => {
        let { salesSummaryV2 } = data;
        if (selectedLocation.locationName === "NA") {
          setSelectedLocation({
            locationNo: salesSummaryV2?.location?.primaryLocationNumber,
            locationName: salesSummaryV2?.location?.primaryLocationName,
          });
          sessionStorage.setItem(
            "selectedLocation",
            JSON.stringify({
              locationNo: salesSummaryV2?.location?.primaryLocationNumber,
              locationName: salesSummaryV2?.location?.primaryLocationName,
            })
          );
        }
      },
    }
  );

  const userEmail = employeeInfo.adUpn;
  useEffect(() => {
    if (userEmail && (activeStorechecker === true || selectedStoreId === "")) {
      getDefaultLocation({
        variables: { request: { email: userEmail, storeId: selectedStoreId } },
        context: {
          headers: {
            Authorization: localStorage.getItem("jwtToken"),
          },
        },
      });
    }
  }, [userEmail, getDefaultLocation, selectedStoreId, activeStorechecker]);

  const [
    getOmniBoipsSummery,
    {
      // eslint-disable-next-line no-unused-vars
      data: { omni: { omni: { bopis } = {} } = {} } = {},
      error: errors = {},
      loading: omnibopis_loading,
    },
  ] = useLazyQuery(GET_OMNI_CHANNEL_SUMMARY);

  useEffect(() => {
    if (
      userEmail &&
      dateMatrix &&
      selectedLocation &&
      selectedLocation?.locationName !== "NA"
    ) {
      getOmniBoipsSummery({
        variables: {
          request: {
            email: userEmail,
            location: {
              primaryLocationNumber: selectedLocation?.locationNo,
              primaryLocationName: selectedLocation?.locationName,
            },
            toDate: getDate("YESTERDAY", ""),
            matrixType: dateMatrix === "YESTERDAY" ? "DAY" : dateMatrix,
          },
        },
        context: {
          headers: {
            Authorization: localStorage.getItem("jwtToken"),
          },
        },
      });
    }
  }, [userEmail, dateMatrix, selectedLocation, getOmniBoipsSummery]);

  return (
    <div className="omni-detail-tab">
      {omnibopis_loading && (
        <div className="omni-detail-loader">
          <CircularProgress color="primary" size={30} />
        </div>
      )}
      {!omnibopis_loading && (
        <>
          {errors.message || locationError.message ? (
            <ErrorMessage
              statusCode={
                errors?.networkError?.statusCode ||
                locationError?.networkError?.statusCode
              }
              message={DATA_FETCH_ERROR}
            />
          ) : null}
          {activeStorechecker === false && selectedStoreId ? (
            <ErrorMessage message={ONLOAN_INVALID_STOREID_ERROR} />
          ) : null}
          <div className="omni-detail-table-container">
            <div className="table-content">
              <div className="flex row">
                <div className="header-text">Buy Online Pick Up in Store</div>
              </div>
              <div className="flex">
                <div className="header-text header-order" style={{fontSize: "1.6rem", paddingLeft:"25px"}}>
                  Total Orders Placed Online{" "}
                  <span className="header-value px-10 py-20">
                    {Math.round(bopis?.ordersPlacedOnline ?? 0).toLocaleString("en")}
                  </span>
                </div>
              </div>

              <div className="omni-detail-collapsible-data-container" style={{paddingLeft: "30px"}}>
               {/* https://fivebelow.atlassian.net/browse/FSERD-6260 */}
                <div className="collapsible-container-data px-10 py-20 ml-0" >
                  <DataRow
                    title="Picked"
                    primaryValue={Math.round(bopis?.picked ?? 0).toLocaleString(
                      "en"
                    )}
                  />
                  <DataRow
                    title="Awaiting Picking"
                    primaryValue={Math.round(
                      bopis?.awaitingPicking ?? 0
                    ).toLocaleString("en")}
                  />
                  <DataRow
                    title="Cancelled"
                    primaryValue={Math.round(
                      bopis?.cancelled ?? 0
                    ).toLocaleString("en")}
                  />
                  <DataRow
                    title="Picked Up by Customer"
                    primaryValue={Math.round(
                      bopis?.pickedByCust ?? 0
                    ).toLocaleString("en")}
                  />
                </div>
              </div>
              <div className="border-row" />
              <div className="px-10 py-20" style={{paddingLeft: "20px"}}>
                <DataRow
                  title="Unit Pick Rate"
                  primaryValue={
                    Math.round(bopis?.pickRate ?? 0).toLocaleString("en") + `%`
                  }
                />
                <DataRow
                  title="Avg Pick Time(Hrs)"
                  primaryValue={bopis?.avgPickTime ?? 0}
                />
                <DataRow
                  title="Orders Abandoned/RTS"
                  primaryValue={Math.round(
                    bopis?.abandoned ?? 0
                  ).toLocaleString("en")}
                />
                <DataRow
                  title="Customer Pick-Up %"
                  primaryValue={
                    Math.round(bopis?.custPickupPercent ?? 0).toLocaleString(
                      "en"
                    ) + `%`
                  }
                />
                <DataRow
                  title="Avg Pick-up Time (Hrs)"
                  primaryValue={bopis?.avgPickUpTime ?? 0}
                />
                <DataRow
                  title="Total Sales $"
                  primaryValue={`$` + (bopis?.totalSales ?? 0)}
                />
                <DataRow
                  title="Total Sales Units"
                  primaryValue={Math.round(
                    bopis?.totalSalesUnits ?? 0
                  ).toLocaleString("en")}
                />
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

OmniChannelDetailTab.propTypes = {
  employeeInfo: PropTypes.shape({ adUpn: PropTypes.string }),
  dateMatrix: PropTypes.string,
};

const mapStateToProps = (state) => {
  return {
    employeeInfo: state.auth.employeeInfo,
    dateMatrix: state?.salesSummary?.currentDateMatrix?.value,
  };
};
export default connect(mapStateToProps, undefined)(OmniChannelDetailTab);
